<template>
  <div class="frisbuy-posts-counter">
    <span class="frisbuy-posts-counter__description">
      Вы посмотрели {{ currentPostsCount }} из {{ allPostsCount }} образов
    </span>

    <div class="frisbuy-posts-counter__progress-bar">
      <div
        class="frisbuy-posts-counter__progress-filler"
        :style="{
            'margin-left': `-${100 - percentOfProgress}%`,
          }"
      ></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-posts-counter {
  width: fit-content;

  margin: 0 auto;

  .frisbuy-posts-counter__description {
    padding: 0 2px;
  }

  .frisbuy-posts-counter__progress-bar {
    width: 100%;
    height: 3px;

    background-color: #e0ebf8;

    overflow: hidden;

    margin-top: 14px;

    .frisbuy-posts-counter__progress-filler {
      width: 100%;
      height: 100%;

      background-color: #002354;

      transition: margin 0.3s cubic-bezier(0.7, 0, 0.7, 1);
    }
  }
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import StoryProgressBar from "@/components/stories/StoryProgressBar.vue";

export default defineComponent({
  components: { StoryProgressBar },

  props: {
    allPostsCount: {
      type: Number,
      required: true,
      validator: (prop: number) => prop > 0,
    },

    currentPostsCount: {
      type: Number,
      required: true,
      validator: (prop: number) => prop >= 0,
    },
  },

  data() {
    return {};
  },

  computed: {
    percentOfProgress(): number {
      return this.currentPostsCount / this.allPostsCount * 100;
    },
  },
});
</script>
